export function ProcessPage() {
  return (
    <section className="section process-page page-sheet">
      <div className="container page-intro">
        <p className="eyebrow">Process</p>
        <h1 className="page-intro__title">How we work</h1>
        <p className="section__intro page-intro__lede">
          A simple flow from first message to launch — no unnecessary meetings.
        </p>
        <ol className="steps process-steps">
          <li>
            <span className="steps__num">1</span>
            <div>
              <strong>Brief on WhatsApp</strong>
              <p>You share goals, timeline, and budget — no long forms.</p>
            </div>
          </li>
          <li>
            <span className="steps__num">2</span>
            <div>
              <strong>Structure &amp; design</strong>
              <p>
                We agree on pages, content, and a look that fits your brand.
              </p>
            </div>
          </li>
          <li>
            <span className="steps__num">3</span>
            <div>
              <strong>Build &amp; launch</strong>
              <p>
                You get a live site with contact flows tested.
              </p>
            </div>
          </li>
        </ol>
      </div>
    </section>
  );
}
